
export class Mouse {
public x: number;
public y: number;
constructor() {
    this.x = 0;
    this.y = 0;
  }
}

function Mouse_tsickle_Closure_declarations() {
/** @type {?} */
Mouse.prototype.x;
/** @type {?} */
Mouse.prototype.y;
}
